import type { Interrogation } from './types.js';

const LIBELLES: Readonly<Record<Interrogation['kind'], string>> = {
  FCDDV: 'FCDDV · dernières volontés',
  FICOVIE: 'FICOVIE · assurances-vie',
  FICOBA: 'FICOBA · comptes bancaires',
  DGFiP: 'DGFiP · créances fiscales',
  CGSS: 'CGSS · créances sociales',
  SPF_immeuble: 'SPF · fiche immeuble',
  SPF_personne: 'SPF · fiche personne',
  syndic: 'Syndic · état daté',
};

export const libelleInterrogation = (kind: Interrogation['kind']): string => LIBELLES[kind];

/** `2026-10-10` devient `10/10/2026`. */
export function dateFr(iso: string): string {
  const [annee, mois, jour] = iso.split('-');
  return `${jour}/${mois}/${annee}`;
}

export function libelleStatutInterrogation(i: Pick<Interrogation, 'status' | 'sentAt' | 'returnedAt'>): string {
  if (i.status === 'revenue') return i.returnedAt ? `retour reçu le ${dateFr(i.returnedAt)}` : 'retour reçu';
  if (i.status === 'envoyee') return i.sentAt ? `envoyée le ${dateFr(i.sentAt)}` : 'envoyée';
  return 'à lancer';
}
